import $ from "jquery";
import api from "./data/cart";

const updateCartQuantity = () => {
  const el = {
    input: {
      qty: ".js-cart_quantity_update",
      field: ".js-number input",
    },
    minicart: {
      content: ".js-minicart",
    },
  };

  $(document).on("blur", el.input.field, function () {
    const $parent = $(this);
    const qty = $parent.val();
    const cart_item_key = $parent.data("cart_item_key");
    const type_tax = $(
      "#myparcel-delivery-options__deliveryMoment--evening"
    ).is(":checked")
      ? "evening"
      : "standard";
    const is_show = $(".header-mini-cart.js-header-mini-cart").hasClass("show");

    api.update_cart_qty(cart_item_key, qty, is_show, type_tax).done((res) => {
      const fragments = res.fragments;
      $.each(fragments, (key, obj) => {
        $(key).html(obj);
      });
      $(el.minicart.content).html(res.html);
    });
  });

  $(document).on("change", el.input.qty, (event) => {
    const $parent = $(event.target);
    const qty = $parent.val();
    const cart_item_key = $parent.data("cart_item_key");
    const type_tax = $(
      "#myparcel-delivery-options__deliveryMoment--evening"
    ).is(":checked")
      ? "evening"
      : "standard";
    const is_show = $(".header-mini-cart.js-header-mini-cart").hasClass("show");

    api.update_cart_qty(cart_item_key, qty, is_show, type_tax).done((res) => {
      const fragments = res.fragments;
      $.each(fragments, (key, obj) => {
        $(key).html(obj);
      });
      $(el.minicart.content).html(res.html);
    });
  });
};

try {
  updateCartQuantity();
} catch (error) {
  // eslint-disable-next-line no-console
  console.error("Error:", error);
}
